/**
 * Checks if a cookie with the given name exists in the document.
 * @param {string} name The name of the cookie to check for.
 * @returns {boolean} true if the cookie exists, false otherwise.
 * @example used by other external scripts to check cookies
 */
function hasCookie(name) {
  const cookies = allCookies();
  if (!cookies) {
    console.debug('No cookies found in consent management.');
    return false;
  }
  return cookies.find((cookie) => cookie === name) !== undefined;
}

/**
 * Get all cookies from the consent management
 * @returns {string[] | null} An array of all cookies or null if no cookies are found
 */
function allCookies() {
  const cookieData = getCookieData();
  if (!cookieData) return null;
  const cookies = [];
  Object.values(cookieData.services).forEach((servicesOfCat) => {
    cookies.push(...servicesOfCat);
  });
  return cookies;
}

/**
 * Get all cookies from the document
 * @returns {CookieConsent.CookieValue | null} An object containing all cookies as key-value pairs
 */
function getCookieData() {
  // Get content of cookie "cc_cookie" {string}
  const consentCookie = document.cookie.split('; ').find((row) => row.startsWith('cc_cookie='));
  // Parse the cookie value into an object
  const cookieValue = consentCookie ? JSON.parse(decodeURIComponent(consentCookie.split('=')[1])) : null;
  // Return the cookie value or an empty object if not found
  return cookieValue;
}
